module.exports = __webpack_public_path__ + "img/bilhao.d2ba46d2.png";